import { CommonData } from "../../datastructures/gamestate/gameData";
import { createMovieClip, createMovieClipTexture } from "../../functions/Functions_General";
import { Button } from "../buttonsLibrary";

export class GambleColorBtn{

    private parent:PIXI.Container;
    private label:PIXI.Text;
    private btnTexture:PIXI.Texture;
    private highLight:PIXI.extras.AnimatedSprite;
    private btn:Button;
    private grayBtnTexture:PIXI.Texture;
    private selectTween:PIXI.tween.Tween;
    private colorIndex:number;
    
    constructor(colorIndex:number,activeGameData:CommonData,parent:PIXI.Container)
    {
        this.parent= new PIXI.Container();
        this.colorIndex=colorIndex
        parent.addChild(this.parent);
        let textStyle= new PIXI.TextStyle({
            fontFamily: activeGameData.gameTextStyle.gameFont,
            fontSize: 30,
            fill: "#ffffff",
            fontWeight: "bold",
            lineHeight: 40,
            align: "center",
      
            dropShadow: true,
            dropShadowColor: "#000000",
            dropShadowBlur: 10,
            dropShadowAngle: Math.PI / 6,
            dropShadowDistance: 0,
          });
        
        this.label= new PIXI.Text(activeGameData.gameTextGeneral.black,textStyle)
        //prepare btn
        if( this.colorIndex==0)//zero red  , one black
        {
            this.btnTexture= (PIXI.Texture.fromImage("redBtn.png"));
            this.label= new PIXI.Text(activeGameData.gameTextGeneral.red,textStyle);
        }
        else
        {
            this.btnTexture=(PIXI.Texture.fromImage("blackBtn.png"));       
            this.label= new PIXI.Text(activeGameData.gameTextGeneral.black,textStyle)
           
        }

        this.grayBtnTexture = PIXI.Texture.fromImage("grayBtn.png");
        // this.btnTexture.anchor.set(.5,0);
        this.label.anchor.set(.5);
      


        this.highLight = createMovieClip("blackBtn", 0, 22);
        this.highLight.x = 0;
        this.highLight.y = 0;
        this.highLight.anchor.set(0.5);
        this.highLight.alpha = 0.5;
        this.highLight.loop = false;
        this.highLight.animationSpeed = 1.2;
        

        this.btn= new Button(
            new PIXI.Sprite(this.btnTexture),
            new PIXI.Rectangle(-175, -50, 350, 100));

        let btnSprite=this.btn.getImage()
        this.parent.addChild(btnSprite);
        btnSprite.addChild(this.label);
        btnSprite.addChild(this.highLight);
        let selectedBtnFx = new PIXI.Sprite(PIXI.Texture.from("gambleSelected.png")    );
        selectedBtnFx.anchor.set(0.5);
        selectedBtnFx.alpha =0;
        this.btn.getImage().addChild(selectedBtnFx);
       
        this.selectTween = PIXI.tweenManager.createTween(selectedBtnFx);
        this.selectTween.time = 1000;
        this.selectTween.loop=false;
        this.selectTween.easing = PIXI.tween.Easing.linear();
        this.selectTween
      .from({ scale: { x: 1, y: 1 }, alpha: 1 })
      .to({ scale: { x: 2, y: 2.4 }, alpha:0 });


        this.setVisible(false);
       
    }

    public setNewStyle=(blackImage:string,RedImage:string,GrayImage:string,overlayAnimationName:string,animationTotalFrames:number=22):void=>
    {   
        if(this.colorIndex==0)
        {
            //-red
            this.btnTexture=(PIXI.Texture.fromImage(RedImage+".png")); 
        }

        else
        {
            //black
            this.btnTexture=(PIXI.Texture.fromImage(blackImage+".png")); 

        }
        this.grayBtnTexture =(PIXI.Texture.fromImage(GrayImage+".png")); 
        this.highLight.textures =createMovieClipTexture(overlayAnimationName, 0, animationTotalFrames);
        
    }
    public setScale=(newScale:number):void=>
    {
        this.parent.scale.set(newScale);
    }
    public setPosition=(pos:Array<number>):void=>
    {
        this.parent.position.set(pos[0], pos[1]);
    }
    public setVisible=(bool:boolean):void=>
    {
        let a=bool?1:0;
        this.btn.setScale(a);
        this.setActive(bool);
    }

    public setActive=(bool:boolean):void=>
    {   

        this.btn.setInteractive(bool);
        if(bool==false)
        {
            this.highLight.gotoAndStop(0);
            this.btn.setNewTexture(this.grayBtnTexture);
        }
        else
        {   
            // this.highLight.gotoAndStop(0);
            this.btn.setNewTexture(this.btnTexture);
        }
    
    
    }
    public setFunction=(newFn:Function):void=>
    {
        this.btn.setFunction(newFn);
    }
    public playHighLight=():void=>
    {
        this.highLight.gotoAndPlay(0);
    }

    public setClicked=():void=>
    {
        this.selectTween.reset();
        this.selectTween.start();
    }
}